import { AttributeCardProps } from "types";

function AttributeCard({
  image,
  name,
  totalTraits,
  width,
  height,
  onClick,
}: AttributeCardProps) {
  return (
    <div
      onClick={onClick}
      className={`bg-[#61A4BC] cursor-pointer rounded-[4px] border border-black flex flex-col shadow-md justify-center items-center p-3 w-[177px] h-[231px]" hover:shadow-black hover:shadow-md`}
    >
      <div className="mb-3 bg-slate-200 border border-opacity-20  rounded border-black">
        <img src={image} className="w-full h-full object-contain rounded" alt="name" />
      </div>
      <p className="font-semibold text-xs text-white w-full text-left">{`${totalTraits} Traits`}</p>
      <p className="font-bold text-[#1A132F] outline-2 w-full text-left whitespace-nowrap text-ellipsis overflow-hidden">
        {name}
      </p>
    </div>
  );
}

export default AttributeCard;
